import * as React from 'react';
import styled from 'styled-components';

import { SEO } from '@/components/global/SEO';
import Page from '@/components/v2/Page';
import { V1PageWrapper } from '@/components/v2/Page/V1PageWrapper';
import { BottomCTATout } from '@components/home/BottomCTATout';

import { IntegrationsTout } from '../components/global/IntegrationsTout';
import { BuildAnythingTout } from '../components/home/BuildAnythingTout';
import { CustomerBanner } from '../components/home/CustomerBanner';
import { CustomerStoriesTout } from '../components/home/CustomerStoriesTout';
import { HeroTout } from '../components/home/HeroTout';
import { ProductOverviewTout } from '../components/home/ProductOverviewTout';
import { SecurityTout } from '../components/home/SecurityTout';

const Wrapper = styled.div`
  width: 100%;
`;

const RefreshPage: React.ComponentType = React.memo(() => {
  return (
    <Page
      seo={
        <SEO
          description="From quick queries, to deep-dive analyses, to beautiful interactive data apps – all in one collaborative, AI-powered workspace."
          title="Bring everyone together with data"
          url="/"
        />
      }>
      <V1PageWrapper>
        <Wrapper>
          <HeroTout />
          <CustomerBanner />
          <ProductOverviewTout />
          <CustomerStoriesTout />
          <IntegrationsTout />
          <SecurityTout />
          <BuildAnythingTout />
          <BottomCTATout />
        </Wrapper>
      </V1PageWrapper>
    </Page>
  );
});

export default RefreshPage;
